import React from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";

class HomeSolutions extends React.Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-primary">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="6">
                      <h1 className="display-3 text-white">
                        Home{" "}
                        <span>Connectivity</span>
                      </h1>
                      <p className="lead text-white">
                        Connect and control all your smart home devices from one unified platform. 
                        Seamless integration, intelligent automation, and intuitive control for 
                        modern homes and families.
                      </p>
                      <div className="btn-wrapper">
                        <Button
                          className="btn-icon mb-3 mb-sm-0"
                          color="info"
                          href="#features"
                        >
                          <span className="btn-inner--icon">
                            <i className="fa fa-home" />
                          </span>
                          <span className="btn-inner--text">
                            See Features
                          </span>
                        </Button>
                        <Button
                          className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                          color="default"
                          tag={Link}
                          to="/contact"
                        >
                          <span className="btn-inner--icon">
                            <i className="fa fa-envelope" />
                          </span>
                          <span className="btn-inner--text">
                            Order Now
                          </span>
                        </Button>
                      </div>
                    </Col>
                    <Col lg="6">
                      <img
                        alt="Home connectivity kit"
                        className="img-fluid"
                        src={require("assets/img/Home_Kit.JPG")}
                        style={{ maxWidth: "100%", borderRadius: "10px" }}
                      />
                    </Col>
                  </Row>
                </div>
              </Container>
            </section>
          </div>

          <section className="section section-lg pt-lg-0 mt--200" id="features">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-info rounded-circle mb-4">
                            <i className="fa fa-sitemap" />
                          </div>
                          <h6 className="text-info text-uppercase">
                            Device Integration
                          </h6>
                          <p className="description mt-3">
                            Connect and control all your smart home devices from one unified platform. 
                            Compatible with major brands and protocols for seamless integration.
                          </p>
                          <div>
                            <span className="badge badge-pill badge-info">
                              WiFi Devices
                            </span>
                            <span className="badge badge-pill badge-info">
                              Zigbee Protocol
                            </span>
                            <span className="badge badge-pill badge-info">
                              Z-Wave Support
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="fa fa-magic" />
                          </div>
                          <h6 className="text-success text-uppercase">
                            Smart Automation
                          </h6>
                          <p className="description mt-3">
                            Create intelligent scenes and automations that adapt to your lifestyle. 
                            Energy-efficient scheduling and responsive environment control.
                          </p>
                          <div>
                            <span className="badge badge-pill badge-success">
                              Scene Control
                            </span>
                            <span className="badge badge-pill badge-success">
                              Smart Scheduling
                            </span>
                            <span className="badge badge-pill badge-success">
                              Energy Savings
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="fa fa-mobile" />
                          </div>
                          <h6 className="text-warning text-uppercase">
                            Easy Management
                          </h6>
                          <p className="description mt-3">
                            Intuitive mobile and web interfaces for managing your connected home. 
                            Voice control integration and family-friendly user experience.
                          </p>
                          <div>
                            <span className="badge badge-pill badge-warning">
                              Mobile App
                            </span>
                            <span className="badge badge-pill badge-warning">
                              Voice Control
                            </span>
                            <span className="badge badge-pill badge-warning">
                              Family Sharing
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Smart Home Integration</h2>
                  <p className="lead text-muted">
                    Seamlessly connect and control all your smart devices from one central hub. 
                    Designed for modern families who want convenience, efficiency, and control.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6" className="order-md-2">
                  <img
                    alt="Smart home monitoring"
                    className="img-fluid floating"
                    src={require("assets/img/theme/Dashboard.png")}
                  />
                </Col>
                <Col md="6" className="order-md-1">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                      <i className="fa fa-cog" />
                    </div>
                    <h3>Universal Device Compatibility</h3>
                    <p className="description mt-3">
                      Our platform works with hundreds of smart home devices and brands:
                    </p>
                    <ul className="list-unstyled mt-3">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-success mr-3">
                              <i className="fa fa-lightbulb" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Smart lights, switches, and dimmers
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-success mr-3">
                              <i className="fa fa-thermometer-half" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Thermostats and climate control systems
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-success mr-3">
                              <i className="fa fa-shield" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Security cameras and door locks
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg bg-secondary">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardBody className="px-4 py-5 text-center">
                      <div className="text-center">
                        <div className="icon icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                          <i className="fa fa-lock text-primary" />
                        </div>
                        <h5 className="text-white">Privacy First</h5>
                        <p className="text-white">
                          All processing happens locally on your device. Your data never 
                          leaves your home network.
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-info shadow rounded-circle mb-5">
                      <i className="fa fa-shield" />
                    </div>
                    <h3>Secure Connectivity</h3>
                    <p className="description mt-3">
                      Enterprise-grade security with home-friendly simplicity:
                    </p>
                    <ul className="list-unstyled mt-3">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-info mr-3">
                              <i className="fa fa-lock" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              End-to-end encryption for all device communications
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-info mr-3">
                              <i className="fa fa-sitemap" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Secure mesh networking for reliable connections
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-info mr-3">
                              <i className="fa fa-user" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Role-based access control for family members
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-5">
                <Col lg="8">
                  <h2 className="display-3">Connectivity Solutions</h2>
                  <p className="lead text-muted">
                    Everything you need to connect and control your smart home devices.
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="6">
                  <Card className=" shadow border-0 text-center">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-primary rounded-circle mb-4 mx-auto">
                        <i className="fa fa-home" />
                      </div>
                      <h6 className="text-primary text-uppercase">
                        Chisp Home Connectivity Kit
                      </h6>
                      <p className="description mt-3">
                        Complete smart home connectivity solution with central hub, 
                        device controllers, and intuitive mobile app.
                      </p>
                      <ul className="list-unstyled mt-3">
                        <li>• Smart Home Hub</li>
                        <li>• Zigbee & Z-Wave Controllers</li>
                        <li>• Mobile App (iOS/Android)</li>
                        <li>• Voice Assistant Integration</li>
                        <li>• Energy Monitoring</li>
                        <li>• 2-Year Warranty</li>
                      </ul>
                      <Button
                        className="btn-round"
                        color="primary"
                        type="button"
                        tag={Link}
                        to="/contact"
                      >
                        Learn More
                      </Button>
                      <p className="text-sm text-muted mt-2">
                        Free consultation | Professional installation available
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default HomeSolutions;